var render, staticRenderFns
import script from "./PortalGrid.vue?vue&type=script&lang=js&"
export * from "./PortalGrid.vue?vue&type=script&lang=js&"
import style0 from "./PortalGrid.vue?vue&type=style&index=0&id=127d1454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127d1454",
  null
  
)

export default component.exports